export default "__VITE_ASSET__BeepxY4V__"